import {positionSurveyContents} from "./positionSurveyContents";
import {checkIfAlreadyProsted} from "../prost/checkIfAlreadyProsted";
import {checkIfAlreadyFavourites} from "../favourites/checkIfAlreadyFavourites";
import {checkIfAlreadyFilled} from "../utils/checkIfAlreadyFilled";
export function loadSurveyContent(ids, furtherParams, shopUserId, lazyLoadOnThisPage) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=load_survey_entries",
        datatype: "json",
        data: {
            "ajax_call_ids": ids,
            "ajax_call_list_community_type": communityType
        },
        success: function (output) {
            positionSurveyContents(output, lazyLoadOnThisPage);
            checkIfAlreadyProsted(ids, "", shopUserId, false, 7);
            checkIfAlreadyFavourites(ids, shopUserId, 7);
            checkIfAlreadyFilled(ids, shopUserId);
        }
    });
}